"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnlineReleaseUpdateService = void 0;
class OnlineReleaseUpdateService {
    constructor(authService, stage) {
        this.authService = authService;
        this.resourceHostId = `myvw-online-release-update-service-${stage}`;
    }
    async getSoftwareInfo(vin) {
        const url = `vehicles/${vin}/software-info`;
        const response = await this.authService.get(this.resourceHostId, url);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
        return await response.json();
    }
}
exports.OnlineReleaseUpdateService = OnlineReleaseUpdateService;
//# sourceMappingURL=OnlineReleaseUpdateService.js.map